var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance-data-analysis-chart"},[_c('div',{ref:"left-chart",staticClass:"left-chart"}),_c('div',{ref:"right-chart",staticClass:"right-chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }